import {
  createConnectedDomain as publicCreateConnectedDomain,
  getConnectedDomain as publicGetConnectedDomain,
  deleteConnectedDomain as publicDeleteConnectedDomain,
  listConnectedDomains as publicListConnectedDomains,
} from './premium-domains-v1-connected-domain-connected-domains.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const createConnectedDomain: MaybeContext<
  BuildRESTFunction<typeof publicCreateConnectedDomain> &
    typeof publicCreateConnectedDomain
> = /*#__PURE__*/ createRESTModule(publicCreateConnectedDomain);
export const getConnectedDomain: MaybeContext<
  BuildRESTFunction<typeof publicGetConnectedDomain> &
    typeof publicGetConnectedDomain
> = /*#__PURE__*/ createRESTModule(publicGetConnectedDomain);
export const deleteConnectedDomain: MaybeContext<
  BuildRESTFunction<typeof publicDeleteConnectedDomain> &
    typeof publicDeleteConnectedDomain
> = /*#__PURE__*/ createRESTModule(publicDeleteConnectedDomain);
export const listConnectedDomains: MaybeContext<
  BuildRESTFunction<typeof publicListConnectedDomains> &
    typeof publicListConnectedDomains
> = /*#__PURE__*/ createRESTModule(publicListConnectedDomains);

export {
  ConnectionType,
  AssignmentType,
  DnsPropagationStatus,
  WebhookIdentityType,
} from './premium-domains-v1-connected-domain-connected-domains.universal.js';
export {
  ConnectedDomain,
  SiteInfo,
  SiteInfoAssignmentInfoOneOf,
  RedirectAssignmentInfo,
  CreateConnectedDomainRequest,
  CreateConnectedDomainResponse,
  GetConnectedDomainRequest,
  GetConnectedDomainResponse,
  DeleteConnectedDomainRequest,
  DeleteConnectedDomainResponse,
  ListConnectedDomainsRequest,
  CursorPaging,
  ListConnectedDomainsResponse,
  CursorPagingMetadata,
  Cursors,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  ListConnectedDomainsOptions,
} from './premium-domains-v1-connected-domain-connected-domains.universal.js';
export {
  ConnectionTypeWithLiterals,
  AssignmentTypeWithLiterals,
  DnsPropagationStatusWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './premium-domains-v1-connected-domain-connected-domains.universal.js';
